/** Add actions on which redux store is going to be called upon */
export const CONVERSATION_SELECTED = "CONVERSATION_SELECTED";
export const UPDATE_CONVERSATION_LOG = "UPDATE_CONVERSATION_LOG";
export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const STATUS_CODE = "STATUS_CODE";
export const USER_NAME = "USER_NAME";
export const CLIENT_MESSAGE_FUNC = "CLIENT_MESSAGE_FUNC";
export const OPERATOR_WATCHLIST = "OPERATOR_WATCHLIST";
export const CENTER_STATUS_LIST = "CENTER_STATUS_LIST";
export const CALL_TAKEN = "CALL_TAKEN";
export const CENTER_LIST = "CENTER_LIST";
export const STATUS_LIST = "STATUS_LIST";
export const CENTER_LIST_CALLHISTORY = "CENTER_LIST_CALLHISTORY";
export const STATUS_LIST_CALLHISTORY = "STATUS_LIST_CALLHISTORY";
export const SUCCESS_CALL_STATUS = "SUCCESS_CALL_STATUS";
export const CALL_RECORD = "CALL_RECORD";
export const CNETR_NAME = "CNETR_NAME";
export const CENTER_PREFIX = "CENTER_PREFIX";
export const CALL_SOURCE = "CALL_SOURCE";
export const MOBILE_NUMBER = "MOBILE_NUMBER";
export const RESPONSE_OF_CALL = "RESPONSE_OF_CALL";
export const CLEAR_CONVERSATION_ID = "CLEAR_CONVERSATION_ID";
export const DATA_CAME_FROM_BACKEND = "DATA_CAME_FROM_BACKEND";

export const CLEAR_CENTER_NAME = "CLEAR_CENTER_NAME";

export const DATA_IS_LOADING = "DATA_IS_LOADING";

export const OPERATOR_CENTER_LIST = "OPERATOR_CENTER_LIST";

export const FETCHING_REFERRAL_FORM="FETCHING_REFERRAL_FORM"
export const INITIATE_WEBSOCKET = "INITIATE_WEBSOCKET";

export const WEBSOCKET_CONNECTION_STATE = "WEBSOCKET_CONNECTION_STATE";

export const INTERNET_CONNECTION_STATUS = "INTERNET_CONNECTION_STATUS";

export const RETRY_TO_CONNECT_WEBSOCKET_IN_SEC =
  "RETRY_TO_CONNECT_WEBSOCKET_IN_SEC";


export const BOT_ERROR="BOT_ERROR";

export const ORDER_SCAN_DETAILS="ORDER_SCAN_DETAILS";

export const SCAN_EXAM_LIST="SCAN_EXAM_LIST";


export const GOT_ERROR_IN_HELP_NOTES="GOT_ERROR_IN_HELP_NOTES"

export const CUSTOMER_LIST= "CUSTOMER_LIST"
export const DIRECT_CALL_STATIC_DATA="DIRECT_CALL_STATIC_DATA"

export const SCAN_LIST="SCAN_LIST"
export const CLIENT_IP="CLIENT_IP"